import { COST_OVERRIDE_MODES, type CostOverrideMode } from "@repo/shared/types";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./advisor-override-select.i18n";

type AdvisorOverrideSelectProps = {
  id: string;
  value: CostOverrideMode;
  onChange: (value: CostOverrideMode) => void;
  disabled?: boolean;
};

/**
 * QL-20 — whether advisors may override a fee per flow instance. The dialogs
 * render it only when the tenant's cost_overrides feature is on.
 */
export function AdvisorOverrideSelect({
  id,
  value,
  onChange,
  disabled,
}: AdvisorOverrideSelectProps) {
  const t = useT(T);
  const labels: Record<CostOverrideMode, string> = {
    off: t.off,
    allowed: t.allowed,
    note_required: t.noteRequired,
  };
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{t.label}</Label>
      <Select
        value={value}
        onValueChange={(next) => onChange(next as CostOverrideMode)}
        disabled={disabled}
      >
        <SelectTrigger id={id}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {COST_OVERRIDE_MODES.map((mode) => (
            <SelectItem key={mode} value={mode}>
              {labels[mode]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-xs text-muted-foreground">{t.description}</p>
    </div>
  );
}
